import { getEquipmentsDetails } from '../services/EquipmentServices';
import { openHtmlInApp } from './openPdfInApp';

function yesNo(value) {
    if (value === true || value === 1 || value === 'true' || value === 'True' || value === 'Active') {
        return 'Yes';
    }
    if (value === false || value === 0 || value === 'false' || value === 'False' || value === 'Inactive') {
        return 'No';
    }
    return value == null || value === '' ? '-' : String(value);
}

function display(value) {
    if (value == null || value === '') return '-';
    return String(value);
}

function num(value, digits = 2) {
    return Number(value || 0).toFixed(digits);
}

export async function printEquipment(cookies, equipmentId, listRow = null) {
    const record = await getEquipmentsDetails(cookies, equipmentId);
    const equipType = record.equip_type?.name || listRow?.equip_type || '-';
    const vendor = record.vendor?.name || listRow?.vendor || '-';
    const status = yesNo(record.status);
    const meterStatus = yesNo(record.meter_status) === 'Yes' ? 'Working' : 'Not Working';

    openHtmlInApp(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>Vehicle / Equipment ${display(record.equip_name)}</title>
            <style>
                body { font-family: Arial, sans-serif; margin: 24px; color: #222; }
                h2 { margin: 0 0 4px; color: #0f1b3d; }
                .sub { color: #64748b; margin-bottom: 18px; font-size: 13px; }
                .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px 24px; margin-bottom: 18px; }
                .grid div { font-size: 13px; }
                .label { color: #64748b; font-weight: 600; margin-right: 6px; }
                table { width: 100%; border-collapse: collapse; margin-top: 8px; }
                th, td { border: 1px solid #cbd5e1; padding: 8px 10px; font-size: 13px; }
                th { background: #e8f4fc; text-align: left; }
                td.num { text-align: right; }
                .section { margin-top: 18px; }
                .section h3 { margin: 0 0 8px; font-size: 14px; color: #186098; }
            </style>
        </head>
        <body>
            <h2>Vehicle / Equipment Details</h2>
            <div class="sub">Fleet master print</div>

            <div class="grid">
                <div><span class="label">Vehicle Type:</span>${display(equipType)}</div>
                <div><span class="label">Vehicle No./Sl.No.:</span>${display(record.equip_name)}</div>
                <div><span class="label">Vendor:</span>${display(vendor)}</div>
                <div><span class="label">Mode:</span>${display(record.mode)}</div>
                <div><span class="label">Capacity:</span>${num(record.capacity)}</div>
                <div><span class="label">Fuel Type:</span>${display(record.fuel_type)}</div>
                <div><span class="label">Meter Status:</span>${meterStatus}</div>
                <div><span class="label">Status:</span>${status === 'Yes' ? 'Active' : 'Inactive'}</div>
                <div><span class="label">Opening Meter:</span>${display(record.meter_reading)}</div>
                <div><span class="label">Opening HM:</span>${display(record.equip_open_hm)}</div>
                <div><span class="label">Avg KM/Litre:</span>${num(record.avg_km_per_litre)}</div>
                <div><span class="label">Current KM:</span>${display(record.co_open_km)}</div>
                <div><span class="label">Current HM:</span>${display(record.co_open_hm)}</div>
                <div><span class="label">Insurance Due:</span>${display(record.insurance_date)}</div>
                <div><span class="label">Permit Due:</span>${display(record.permit_date)}</div>
                <div><span class="label">FC Due:</span>${display(record.fc_date)}</div>
            </div>

            <div class="section">
                <h3>Period Summary</h3>
                <table>
                    <thead>
                        <tr>
                            <th>KM</th>
                            <th>HM</th>
                            <th>Qty</th>
                            <th>Trips</th>
                            <th>Diesel</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="num">${num(listRow?.km ?? record.co_open_km, 0)}</td>
                            <td class="num">${num(listRow?.hm ?? record.co_open_hm, 0)}</td>
                            <td class="num">${num(listRow?.qty, 2)}</td>
                            <td class="num">${num(listRow?.trips, 0)}</td>
                            <td class="num">${num(listRow?.diesel, 2)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="section">
                <h3>Remarks</h3>
                <div>${display(record.user_remarks)}</div>
            </div>
        </body>
        </html>
    `, { title: `Vehicle ${display(record.equip_name)}` });
}
